import React from 'react';
import styled from '@emotion/styled';
const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const ErrorMessage = styled.div``;
const ErrorInvokeKey = styled.div`
  color: #ccc;
  font-size: 9px;
  text-align: right;
  margin-top: 5px;
`;
export const FlagErrorBodyWithInvokeKey = ({ invokeKey, errorMessage }: { invokeKey: string; errorMessage: string }) => {
  let errorMessageReplaced = errorMessage;
  if (invokeKey === 'CREATE_CUSTOMFIELD_OPTION' && errorMessage === 'Bad Request') {
    errorMessageReplaced = 'Duplicate Option (Bad Request).';
  }
  return (
    <ErrorContainer>
      <ErrorMessage>{errorMessageReplaced}</ErrorMessage>
      <ErrorInvokeKey>[{invokeKey}]</ErrorInvokeKey>
    </ErrorContainer>
  );
};
